var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getTag,{tag:"component",class:[_vm.getClass, _vm.getColor, _vm.getTextAlign, _vm.getFontWeight]},[_vm._t("default"),(_vm.hasBorder)?_c('div',{staticClass:"pt-4 mb-8 border-b border-gray-300"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }